export enum PlayerType {
  MAIN = 'main',
  AUDIO = 'audio'
}
